if (!customElements.get('tabbed-product-collections')) {
  class TabbedProductCollections extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      this.addEventListener('shopify:block:select', this.onBlockSelect);

      const activeGroup = this.querySelector('[data-tpc-group-panel][aria-hidden="false"]')
        || this.querySelector('[data-tpc-group-panel]');

      if (activeGroup) {
        this.activateGroup(activeGroup.dataset.tpcGroupPanel, false);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    onClick(event) {
      const groupButton = event.target.closest('[data-tpc-group-target]');
      if (groupButton && this.contains(groupButton)) {
        event.preventDefault();
        this.activateGroup(groupButton.dataset.tpcGroupTarget, true);
        return;
      }

      const filterButton = event.target.closest('[data-tpc-filter-target]');
      if (filterButton && this.contains(filterButton)) {
        event.preventDefault();
        this.activateFilter(filterButton, true);
      }
    }

    onBlockSelect(event) {
      const panel = event.target.closest?.('[data-tpc-group-panel]');
      if (!panel || !this.contains(panel)) return;

      this.activateGroup(panel.dataset.tpcGroupPanel, false);
    }

    activateGroup(handle, shouldFocus = false) {
      if (!handle) return;

      const groupButtons = this.querySelectorAll('[data-tpc-group-target]');
      const groupPanels = this.querySelectorAll('[data-tpc-group-panel]');
      let activePanel = null;
      let activeButton = null;

      groupButtons.forEach((button) => {
        const isActive = button.dataset.tpcGroupTarget === handle;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.setAttribute('tabindex', isActive ? '0' : '-1');
        if (isActive) activeButton = button;
      });

      groupPanels.forEach((panel) => {
        const isActive = panel.dataset.tpcGroupPanel === handle;
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        if (isActive) activePanel = panel;
      });

      if (!activePanel) return;

      let activeFilter = activePanel.querySelector('[data-tpc-filter-target].is-active');
      if (!activeFilter) {
        activeFilter = activePanel.querySelector('[data-tpc-filter-target]');
      }

      if (activeFilter) {
        this.activateFilter(activeFilter, false);
      } else {
        this.updateCount(activePanel.dataset.productCount || 0);
      }

      if (shouldFocus && activeButton) activeButton.focus({ preventScroll: true });
    }

    activateFilter(button, shouldFocus = false) {
      const groupPanel = button.closest('[data-tpc-group-panel]');
      if (!groupPanel) return;

      const handle = button.dataset.tpcFilterTarget;
      const filterButtons = groupPanel.querySelectorAll('[data-tpc-filter-target]');
      const filterPanels = groupPanel.querySelectorAll('[data-tpc-filter-panel]');

      filterButtons.forEach((filterButton) => {
        const isActive = filterButton === button;
        filterButton.classList.toggle('is-active', isActive);
        filterButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
        filterButton.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      filterPanels.forEach((panel) => {
        const isActive = panel.dataset.tpcFilterPanel === handle;
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      this.updateCount(button.dataset.productCount || 0);
      if (shouldFocus) button.focus({ preventScroll: true });
    }

    updateCount(value) {
      const countElement = this.querySelector('[data-tpc-count]');
      if (!countElement) return;

      const count = Number.parseInt(value, 10) || 0;
      const singular = this.dataset.productLabelSingular || 'Product';
      const plural = this.dataset.productLabelPlural || 'Products';
      const label = count === 1 ? singular : plural;

      countElement.textContent = `${count} ${label}`;
    }
  }

  customElements.define('tabbed-product-collections', TabbedProductCollections);
}